import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// import { VApp,
// VAppBar,
// VAlert,
// VAutocomplete,
// VAvatar,
// VBadge,
// VBanner,
// VBottomNavigation,
// VBottomSheet,
// VBreadcrumbs,
// VBtn,
// VBtnToggle,
// VCalendar,
// VCard,
// VCarousel,
// VCheckbox,
// VChip,
// VChipGroup,
// VColorPicker,
// VContent,
// VCombobox,
// VCounter,
// VData,
// VDataIterator,
// VDataTable,
// VDatePicker,
// VDialog,
// VDivider,
// VExpansionPanel,
// VFileInput,
// VFooter,
// VForm,
// // VGrid,
// VHover,
// VIcon,
// VImg,
// VInput,
// VItemGroup,
// VLabel,
// VLazy,
// VList,
// VMain,
// VMenu,
// VMessages,
// VNavigationDrawer,
// VOtpInput,
// VOverflowBtn,
// VOverlay,
// VPagination,
// VSheet,
// VParallax,
// VPicker,
// VProgressCircular,
// VProgressLinear,
// VRadioGroup,
// VRangeSlider,
// VRating,
// VResponsive,
// VSelect,
// VSkeletonLoader,
// VSlider,
// VSlideGroup,
// VSnackbar,
// VSparkline,
// VSpeedDial,
// VStepper,
// VSubheader,
// VSwitch,
// VSystemBar,
// VTabs,
// VTextarea,
// VTextField,
// VThemeProvider,
// VTimeline,
// VTimePicker,
// VToolbar,
// VTooltip,
// VTreeview,
// VVirtualScroll,
// VWindow,
// } from 'vuetify/src/components';
//
// export const Components = {
// "v-app": VApp,
// "v-app-bar": VAppBar,
// "v-alert": VAlert,
// "v-autocomplete": VAutocomplete,
// "v-avatar": VAvatar,
// "v-badge": VBadge,
// "v-banner": VBanner,
// "v-bottom-navigation": VBottomNavigation,
// "v-bottom-sheet": VBottomSheet,
// "v-breadcrumbs": VBreadcrumbs,
// "v-btn": VBtn,
// "v-btn-toggle": VBtnToggle,
// "v-calendar": VCalendar,
// "v-card": VCard,
// "v-carousel": VCarousel,
// "v-checkbox": VCheckbox,
// "v-chip": VChip,
// "v-chip-group": VChipGroup,
// "v-color-picker": VColorPicker,
// "v-content": VContent,
// "v-combobox": VCombobox,
// "v-counter": VCounter,
// "v-data": VData,
// "v-data-iterator": VDataIterator,
// "v-data-table": VDataTable,
// "v-date-picker": VDatePicker,
// "v-dialog": VDialog,
// "v-divider": VDivider,
// "v-expansion-panel": VExpansionPanel,
// "v-file-input": VFileInput,
// "v-footer": VFooter,
// "v-form": VForm,
// "v-hover": VHover,
// "v-icon": VIcon,
// "v-img": VImg,
// "v-input": VInput,
// "v-item-group": VItemGroup,
// "v-label": VLabel,
// "v-lazy": VLazy,
// "v-list": VList,
// "v-main": VMain,
// "v-menu": VMenu,
// "v-messages": VMessages,
// "v-navigation-drawer": VNavigationDrawer,
// "v-otp-input": VOtpInput,
// "v-overflow-btn": VOverflowBtn,
// "v-overlay": VOverlay,
// "v-pagination": VPagination,
// "v-sheet": VSheet,
// "v-parallax": VParallax,
// "v-picker": VPicker,
// "v-progress-circular": VProgressCircular,
// "v-progress-linear": VProgressLinear,
// "v-radio-group": VRadioGroup,
// "v-range-slider": VRangeSlider,
// "v-rating": VRating,
// "v-responsive": VResponsive,
// "v-select": VSelect,
// "v-skeleton-loader": VSkeletonLoader,
// "v-slider": VSlider,
// "v-slide-group": VSlideGroup,
// "v-snackbar": VSnackbar,
// "v-sparkline": VSparkline,
// "v-speed-dial": VSpeedDial,
// "v-stepper": VStepper,
// "v-subheader": VSubheader,
// "v-switch": VSwitch,
// "v-system-bar": VSystemBar,
// "v-tabs": VTabs,
// "v-textarea": VTextarea,
// "v-text-field": VTextField,
// "v-theme-provider": VThemeProvider,
// "v-timeline": VTimeline,
// "v-time-picker": VTimePicker,
// "v-toolbar": VToolbar,
// "v-tooltip": VTooltip,
// "v-treeview": VTreeview,
// "v-virtual-scroll": VVirtualScroll,
// "v-window": VWindow,
// }


Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#035b99',
        secondary: '#686868',
        accent: '#48c1c3',
        blue: '#035b99',
        grey: '#686868',
        info: '#035b99',
        red: '#ff5252',
      },
      dark: {
        primary: '#035b99',
        accent: '#48c1c3',
        info: '#035b99',
        blue: '#035b99',
        grey: '#686868',
        red: '#ff5252',
      }
    }
  }
}
//gray #686868

export const vuetify = new Vuetify(opts)
